import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UserSettingsComponent } from "./user-settings/user-settings.component";
import { UserSettingsRoutingModule } from "./user-settings-routing.module";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations: [
    UserSettingsComponent
  ],
  imports: [
    CommonModule,
    UserSettingsRoutingModule,
    SharedModule
  ]
})
export class UserSettingsModule {}
